export const levelModifier: Record<string, number> = {
    Junior: 0.59,
    Intermediate: 0.78,
    Senior: 1,
    Staff: 1.2,
}
